export default {"src":"/_next/static/image/public/images/ic_umbrella_small.63dd1af5d69ff4c380535f24568136e3.svg","height":35,"width":31};